import {Alert, Box, Grid, ListItem, ListItemButton, ListItemText, Paper, Typography} from "@mui/material";
import Modal from '@mui/material/Modal';
import axios from 'axios';
import * as React from "react";
import {
    DataGrid,
    GridColDef,
    GridToolbarContainer,
    GridToolbarFilterButton
} from '@mui/x-data-grid';

import { FixedSizeList, ListChildComponentProps  } from 'react-window';
import { LazyLog } from 'react-lazylog';
import {useContext, useEffect} from "react";
import {IDPoolContext,Devices,identityServer,apiVersion} from "../Context/IDContext";

const LazyLogComponent = LazyLog as unknown as React.ComponentType<any>;

interface IDeviceLog {
    logMac: string;
    logHost: string;
    logName:string;
    logSize:number;
    logDate:Date;
}

const style = {
    position: 'absolute' as 'absolute',
    left: '10%',
    top: '10%',
    width: '80%',
    height: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow:'scroll',
};

const columns:GridColDef[] = [
    {field:"serialNumber",width:130},
    {field:"mac",width:140},
    {field:"lastUpdate",width:175}
    ]

const logColumns:GridColDef[] = [
    {field:"logName",width:130},
    {field:"logSize",width:140},
    {field:"logDate",width:175}
]

const defaultLog:IDeviceLog = {
    logMac: "",
    logHost: "",
    logName:"",
    logSize: 0,
    logDate: new Date
}

const defaultRefreshInterval = 300000 // refresh entire device list every 30 seconds while log view is open

export function LogViewer() {
    const {
        devices,
        loading,
        error,
        accessToken,
        updateDeviceData } = useContext(IDPoolContext)

    const [logViewHost, setLogViewHost]: [string, (logViewHost: string) => void] = React.useState("");
    const [logViewLogs, setLogViewLogs]: [IDeviceLog[],(logViewLogs: IDeviceLog[]) => void] = React.useState<IDeviceLog[]>([]);
    const [currentLog,setCurrentLog]: [IDeviceLog,(currentLog: IDeviceLog) => void] = React.useState(defaultLog);
    const [currentLogUrl, setCurrentLogUrl]: [string, (currentLogUrl: string) => void] = React.useState("");
    const [openLog, setOpenLog] = React.useState(false);
    const [logError, setLogError]: [string, (logError: string) => void] = React.useState("");
    const [logLoading, setLogLoading]: [boolean, (logLoading: boolean) => void] = React.useState<boolean>(true);
    const [hostRows,setHostRows]:[Devices[],(hostRows: Devices[])=>void] = React.useState<Devices[]>([]);
    const [refreshInterval, setRefreshInterval] = React.useState(0);

    const handleCloseLog = () => setOpenLog(false);

    useEffect(()=>{
        let newHostRows: Devices[] = []
        let interval:any

        for(let device in devices) {
            newHostRows.push(devices[device]);
        }
        setHostRows(newHostRows)

        if (refreshInterval && refreshInterval > 0) {
            if (updateDeviceData != undefined)
                interval = setInterval(updateDeviceData, refreshInterval);
        } else {
            if (updateDeviceData != undefined)
                updateDeviceData();
            setRefreshInterval(defaultRefreshInterval);
        }
        return () => {
            clearInterval(interval);
        }

    },[devices,updateDeviceData,refreshInterval])
    var fetchOptions ={ headers: {
        "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`,
    } }
    return (
        <div>
            {loading && <Alert severity="info">Waiting for Server</Alert>}
            {error && <Alert severity="error">{error}</Alert>}
            {!error &&
                <Paper elevation={3} sx={{mt: 1, p: 5}}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                                <DataGrid
                                    autoHeight
                                    autoPageSize
                                    rows={hostRows}
                                    columns={columns}
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                    density="compact"
                                    getRowId={(row) => row.mac}
                                    components={{ Toolbar: CustomToolBar }}
                                    onRowClick={(row) =>{
                                        showDeviceLogs(row.row["mac"],row.row["serialNumber"])
                                    }}
                                    initialState={{
                                        sorting: {
                                            sortModel: [{ field: 'lastUpdate', sort: 'desc' }],
                                        },
                                    }}
                                />
                        </Grid>
                        <Grid item xs={6}>
                            <Modal
                                open={openLog}
                                onClose={handleCloseLog}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={style}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2">
                                        {currentLog.logName != '' ? currentLog.logName + " - " +
                                            currentLog.logHost + " [ " +
                                            currentLog.logMac + " ]" : 'No Log'}
                                    </Typography>
                                    <Box sx={{width: '100%', height: '90%'}}>
                                        <LazyLogComponent enableSearch url={currentLogUrl} fetchOptions={fetchOptions}/>
                                    </Box>
                                    Log Saved: {currentLog.logName != '' ? currentLog.logDate : "No Logs"}
                                </Box>
                            </Modal>
                            {logLoading && <Alert severity="info">Select a Host to view Logs</Alert>}
                            {logError && <Alert severity="error">{logError}</Alert>}
                            {!logLoading &&
                                    <DataGrid
                                        autoHeight
                                        rows={logViewLogs}
                                        columns={logColumns}
                                        pageSize={10}
                                        rowsPerPageOptions={[10]}
                                        density="compact"
                                        getRowId={(row) => row.logName}
                                        components={{ Toolbar: CustomToolBar }}
                                        onRowClick={(row) =>{
                                            showLog(row.row["logName"])
                                        }}
                                    />


                            }
                        </Grid>
                    </Grid>
                </Paper>
            }
        </div>

    )

    function CustomToolBar() {
        return (
            <GridToolbarContainer>
                <GridToolbarFilterButton />
            </GridToolbarContainer>
        )
    }

    function showLog(logName:string) {
        for (let i in logViewLogs) {
            if(logViewLogs[i].logName === logName) {
                setCurrentLogUrl(identityServer + "/api/"+apiVersion+"/logs/"+logViewLogs[i].logMac+"/"+logViewLogs[i].logHost+"/"+logViewLogs[i].logName+"?cb=" + Date.now())
                setCurrentLog(logViewLogs[i])
                setOpenLog(true);
            }
        }
    }

    function showDeviceLogs(logMac:string,logHost:string) {
            setLogViewHost(logHost + " [ " + logMac +" ]");
            fetchLogData(logMac,logHost);
    }


    function fetchLogData(deviceMacAddress:string,deviceHost:string) {
        let devicePath = deviceMacAddress
        if (deviceHost !== "") {
            devicePath += "/"+deviceHost
        }
        axios
            .get<IDeviceLog[]>(identityServer + "/api/"+apiVersion+"/logs/"+devicePath+"?cb=" + Date.now(), {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${accessToken}`,
                    },
                timeout: 15000
            }).then(response => {

            setLogViewLogs(response.data)
            setLogError("")
            setLogLoading(false)
        }).catch(ex => {
            let error = "Logs not found";
            setLogError(error)
        });
    }
}
